import type { Airflow } from '@aviata/platform-types';

import { api } from '@/shared/api';

export function startSearch(
  query: string,
  callback?: (search: Airflow.Search.Meta) => void,
): Promise<Airflow.Search.Result> {
  return api.airflow
    .search(query)
    .then(res => res.data)
    .then(search => {
      if (callback && typeof callback === 'function') {
        callback(search.$meta as unknown as Airflow.Search.Meta);
      }
      return search;
    })
    .then(search => api.airflow.pollResults(search.id, search.$meta))
    .then(res => res.data as unknown as Airflow.Search.Result);
}
